/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Webplatform-ts V2 API
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetV2EmployeeAgreementsTos200,
  HandlersEmployeeAgreementStatus,
  PutV2EmployeeAgreementsPrivacy200,
  PutV2EmployeeAgreementsPrivacyBody,
  PutV2EmployeeAgreementsTos200,
  PutV2EmployeeAgreementsTosBody
} from '../../model';

import { webplatformProxyInstance } from '../../../../../lib/integrations/axios.ts';
import type { ErrorType } from '../../../../../lib/integrations/axios.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * This endpoint will return last accepted date of employee privacy agreement
 * @summary An endpoint to request employee agreement
 */
export const getV2EmployeeAgreementsPrivacy = (

 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<HandlersEmployeeAgreementStatus>(
      {url: `/v2/employee/agreements/privacy`, method: 'GET', signal
    },
      options);
    }




export const getGetV2EmployeeAgreementsPrivacyQueryKey = () => {
    return [
    `/v2/employee/agreements/privacy`
    ] as const;
    }


export const getGetV2EmployeeAgreementsPrivacyQueryOptions = <TData = Awaited<ReturnType<typeof getV2EmployeeAgreementsPrivacy>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2EmployeeAgreementsPrivacy>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV2EmployeeAgreementsPrivacyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV2EmployeeAgreementsPrivacy>>> = ({ signal }) => getV2EmployeeAgreementsPrivacy(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV2EmployeeAgreementsPrivacy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV2EmployeeAgreementsPrivacyQueryResult = NonNullable<Awaited<ReturnType<typeof getV2EmployeeAgreementsPrivacy>>>
export type GetV2EmployeeAgreementsPrivacyQueryError = ErrorType<unknown>


export function useGetV2EmployeeAgreementsPrivacy<TData = Awaited<ReturnType<typeof getV2EmployeeAgreementsPrivacy>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2EmployeeAgreementsPrivacy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2EmployeeAgreementsPrivacy>>,
          TError,
          Awaited<ReturnType<typeof getV2EmployeeAgreementsPrivacy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV2EmployeeAgreementsPrivacy<TData = Awaited<ReturnType<typeof getV2EmployeeAgreementsPrivacy>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2EmployeeAgreementsPrivacy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2EmployeeAgreementsPrivacy>>,
          TError,
          Awaited<ReturnType<typeof getV2EmployeeAgreementsPrivacy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV2EmployeeAgreementsPrivacy<TData = Awaited<ReturnType<typeof getV2EmployeeAgreementsPrivacy>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2EmployeeAgreementsPrivacy>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary An endpoint to request employee agreement
 */

export function useGetV2EmployeeAgreementsPrivacy<TData = Awaited<ReturnType<typeof getV2EmployeeAgreementsPrivacy>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2EmployeeAgreementsPrivacy>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV2EmployeeAgreementsPrivacyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Allow clients to update their Privacy policy with an accepted or unaccepted status.
 * @summary Update Employee TOS acceptance
 */
export const putV2EmployeeAgreementsPrivacy = (
    putV2EmployeeAgreementsPrivacyBody: PutV2EmployeeAgreementsPrivacyBody,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<PutV2EmployeeAgreementsPrivacy200>(
      {url: `/v2/employee/agreements/privacy`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putV2EmployeeAgreementsPrivacyBody, signal
    },
      options);
    }




export const getPutV2EmployeeAgreementsPrivacyMutationKey = () => ['putV2EmployeeAgreementsPrivacy'] as const;

export const getPutV2EmployeeAgreementsPrivacyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV2EmployeeAgreementsPrivacy>>, TError,PutV2EmployeeAgreementsPrivacyMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putV2EmployeeAgreementsPrivacy>>, TError,PutV2EmployeeAgreementsPrivacyMutationVariables, TContext> => {

const mutationKey = getPutV2EmployeeAgreementsPrivacyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putV2EmployeeAgreementsPrivacy>>, PutV2EmployeeAgreementsPrivacyMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putV2EmployeeAgreementsPrivacy(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutV2EmployeeAgreementsPrivacyMutationResult = NonNullable<Awaited<ReturnType<typeof putV2EmployeeAgreementsPrivacy>>>
    export type PutV2EmployeeAgreementsPrivacyMutationBody = PutV2EmployeeAgreementsPrivacyBody
    export type PutV2EmployeeAgreementsPrivacyMutationError = ErrorType<unknown>
    export type PutV2EmployeeAgreementsPrivacyMutationVariables = {data: PutV2EmployeeAgreementsPrivacyBody}

    /**
 * @summary Update Employee TOS acceptance
 */
export const usePutV2EmployeeAgreementsPrivacy = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV2EmployeeAgreementsPrivacy>>, TError,PutV2EmployeeAgreementsPrivacyMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putV2EmployeeAgreementsPrivacy>>,
        TError,
        PutV2EmployeeAgreementsPrivacyMutationVariables,
        TContext
      > => {
      return useMutation(getPutV2EmployeeAgreementsPrivacyMutationOptions(options), queryClient);
    }
    /**
 * This endpoint will return last accepted date of employee TOS agreement
 * @summary An endpoint to request employee agreement
 */
export const getV2EmployeeAgreementsTos = (

 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<GetV2EmployeeAgreementsTos200>(
      {url: `/v2/employee/agreements/tos`, method: 'GET', signal
    },
      options);
    }




export const getGetV2EmployeeAgreementsTosQueryKey = () => {
    return [
    `/v2/employee/agreements/tos`
    ] as const;
    }


export const getGetV2EmployeeAgreementsTosQueryOptions = <TData = Awaited<ReturnType<typeof getV2EmployeeAgreementsTos>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2EmployeeAgreementsTos>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV2EmployeeAgreementsTosQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV2EmployeeAgreementsTos>>> = ({ signal }) => getV2EmployeeAgreementsTos(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV2EmployeeAgreementsTos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV2EmployeeAgreementsTosQueryResult = NonNullable<Awaited<ReturnType<typeof getV2EmployeeAgreementsTos>>>
export type GetV2EmployeeAgreementsTosQueryError = ErrorType<unknown>


export function useGetV2EmployeeAgreementsTos<TData = Awaited<ReturnType<typeof getV2EmployeeAgreementsTos>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2EmployeeAgreementsTos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2EmployeeAgreementsTos>>,
          TError,
          Awaited<ReturnType<typeof getV2EmployeeAgreementsTos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV2EmployeeAgreementsTos<TData = Awaited<ReturnType<typeof getV2EmployeeAgreementsTos>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2EmployeeAgreementsTos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2EmployeeAgreementsTos>>,
          TError,
          Awaited<ReturnType<typeof getV2EmployeeAgreementsTos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV2EmployeeAgreementsTos<TData = Awaited<ReturnType<typeof getV2EmployeeAgreementsTos>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2EmployeeAgreementsTos>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary An endpoint to request employee agreement
 */

export function useGetV2EmployeeAgreementsTos<TData = Awaited<ReturnType<typeof getV2EmployeeAgreementsTos>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2EmployeeAgreementsTos>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV2EmployeeAgreementsTosQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Allow clients to update their TOS policy with an accepted or unaccepted status.
 * @summary Update Employee TOS acceptance
 */
export const putV2EmployeeAgreementsTos = (
    putV2EmployeeAgreementsTosBody: PutV2EmployeeAgreementsTosBody,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<PutV2EmployeeAgreementsTos200>(
      {url: `/v2/employee/agreements/tos`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putV2EmployeeAgreementsTosBody, signal
    },
      options);
    }




export const getPutV2EmployeeAgreementsTosMutationKey = () => ['putV2EmployeeAgreementsTos'] as const;

export const getPutV2EmployeeAgreementsTosMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV2EmployeeAgreementsTos>>, TError,PutV2EmployeeAgreementsTosMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putV2EmployeeAgreementsTos>>, TError,PutV2EmployeeAgreementsTosMutationVariables, TContext> => {

const mutationKey = getPutV2EmployeeAgreementsTosMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putV2EmployeeAgreementsTos>>, PutV2EmployeeAgreementsTosMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putV2EmployeeAgreementsTos(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutV2EmployeeAgreementsTosMutationResult = NonNullable<Awaited<ReturnType<typeof putV2EmployeeAgreementsTos>>>
    export type PutV2EmployeeAgreementsTosMutationBody = PutV2EmployeeAgreementsTosBody
    export type PutV2EmployeeAgreementsTosMutationError = ErrorType<unknown>
    export type PutV2EmployeeAgreementsTosMutationVariables = {data: PutV2EmployeeAgreementsTosBody}

    /**
 * @summary Update Employee TOS acceptance
 */
export const usePutV2EmployeeAgreementsTos = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV2EmployeeAgreementsTos>>, TError,PutV2EmployeeAgreementsTosMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putV2EmployeeAgreementsTos>>,
        TError,
        PutV2EmployeeAgreementsTosMutationVariables,
        TContext
      > => {
      return useMutation(getPutV2EmployeeAgreementsTosMutationOptions(options), queryClient);
    }
